import React from 'react';

import { DutyHourTypeDynFlag } from 'generated';
import { useTranslation } from 'react-i18next';

import { ControlledFlagCheckbox } from 'components/shared/ControlledFields/ControlledFlagCheckbox';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

export const RosterPlanSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <MultiStepForm.Section title={t('dutyHourTypes.section.roster_plan')}>
      <ControlledFlagCheckbox<DutyHourTypeDynFlag>
        name="flags"
        flag="SHORTLIST"
        label={t('dutyHourTypes.fieldName.rosterShortlist')}
      />
      <ControlledFlagCheckbox<DutyHourTypeDynFlag>
        name="flags"
        flag="NOT_ON_DAY_ROSTER"
        label={t('dutyHourTypes.fieldName.notOnDayRoster')}
      />
    </MultiStepForm.Section>
  );
};
